import { Checkbox } from '@/components/ui/checkbox';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { useFormContext } from 'react-hook-form';

export const MaybeTryOn = ({ isTryOn }: { isTryOn: boolean }) => {
  const form = useFormContext();

  if (!isTryOn) {
    return null;
  }

  return (
    <div className='px-2.5 lg_px-0'>
      <FormField
        control={form.control}
        name='isTryOn'
        render={({ field }) => (
          <FormItem className='flex flex-col items-start space-x-0 space-y-0'>
            <ul className='mb-[15px] font-jost text-sm leading-[20px] text-[#5e5047]'>
              <li>1. Select up to 3 dresses at once for just $10 each dress.</li>
              <li>2. Try on your dress and keep it for 5 days.</li>
              <li>3. Return it by download return label on our website in your account.</li>
              {isTryOn ? <li>4. Home try on dresses are only available for shipping to the United States.</li> : null}
            </ul>

            <div className='flex gap-3'>
              <FormControl>
                <Checkbox
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
              <div className='space-y-1 text-sm leading-none'>
                <FormLabel className='text-sm lg_text-sm'>
                  I read and agree to return the dress within 5 days. Otherwise I will be charged full price of the
                  dress.
                </FormLabel>
              </div>
            </div>
            <FormMessage id={'isTryOn'} />
          </FormItem>
        )}
      />
    </div>
  );
};
